import { initSentry } from './lib/sentry';
import { initUmami } from './lib/umami';

initSentry();
initUmami();

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import { ThemeProvider } from './hooks/useTheme';
import './styles/globals.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

// Dev API interceptor: tree-shaken out of production builds
if (import.meta.env.DEV) {
  import('./lib/dev-api-interceptor').then(({ setupDevApiInterceptor }) => {
    setupDevApiInterceptor();
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          {/*
            No `future` flags: on v7 the behaviours they used to opt into
            (startTransition around navigation, relative resolution inside
            splat routes) are the default, and passing the prop is a type
            error. They were set on v6 first so the behaviour change and the
            version bump could be verified separately.
          */}
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ThemeProvider>
      </QueryClientProvider>
    </HelmetProvider>
  </React.StrictMode>
);
